module.exports = __webpack_public_path__ + "img/xybjThree.9bcaa9a1.jpg";